import api from './index.js'

export function getInventoryLedgerList(params) {
  return api.get('/api/v1/inventory/ledgers', { params })
}

export function getInventoryProductStocks(params) {
  return api.get('/api/v1/inventory/product-stocks', { params })
}

export function createHqInbound(data) {
  return api.post('/api/v1/inventory/hq-inbounds', data)
}

export function getInventoryTransfers(params) {
  return api.get('/api/v1/inventory/transfers', { params })
}

export function createInventoryTransfer(data) {
  return api.post('/api/v1/inventory/transfers', data)
}

export function receiveInventoryTransfer(transferCode, data) {
  return api.post(`/api/v1/inventory/transfers/${transferCode}/receive`, data)
}
